module.exports = __webpack_public_path__ + "assets/img/login_bg.a95c1762.jpg";